import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { animationEndEffect, range } from 'utils';

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/game/SegmentedProgressBar.scss';

const ProgressBarSegment = ({
  progressNum = 0,
  segmentNum = 0
}) => {

  const {
    active= false, complete = false, animationEndHandler
  } = animationEndEffect({
    activeCondition: (progressNum === (segmentNum + 1)), completeCondition: (progressNum > segmentNum),
    effectDependencies: [progressNum, segmentNum], animationEventName: 'cswSegmentedProgressBarLoader'
  });

  return (
    <div className={classNames('csw-progress-bar-segment', {
           'active': active,
           'complete': complete
         })}
         key={`progress-segment-${segmentNum}`}
         onAnimationEnd={animationEndHandler} />
  );
};

ProgressBarSegment.propTypes /* remove-proptypes */ = {
  progressNum: PropTypes.number,
  segmentNum: PropTypes.number,
};

const SegmentedProgressBar = ({
  id,
  progressNum = 0,
  totalNum = 0,
  showProgressBar = false,
  className,
  progressTitle
}) => {
  const hasProgress = !((isNaN(progressNum) || progressNum === 0) && (isNaN(totalNum) || totalNum === 0));
  const isBar = (hasProgress && totalNum > 1) && showProgressBar;

  return (
    isBar ?
    <div className={classNames('csw-segmented-progress-bar', className)}
         role="progressbar"
         aria-valuenow={progressNum}
         aria-valuemax={totalNum}
         title={progressTitle}
         aria-label={progressTitle}
         id={id}
         data-testid={id}>
      {range(totalNum).map((i) => (
        <ProgressBarSegment segmentNum={i} progressNum={progressNum} key={`progress-segment-${i}`} />
      ))}
    </div> : null
  );
};

SegmentedProgressBar.propTypes /* remove-proptypes */ = {
  id: PropTypes.string.isRequired,
  progressNum: PropTypes.number,
  showProgressBar: PropTypes.bool,
  totalNum: PropTypes.number,
  className: PropTypes.string,
  progressTitle: PropTypes.string,
};

export default SegmentedProgressBar;
